import { render, staticRenderFns } from "./informationExpanded.vue?vue&type=template&id=fba2dbf2&scoped=true&"
import script from "./informationExpanded.vue?vue&type=script&lang=js&"
export * from "./informationExpanded.vue?vue&type=script&lang=js&"
import style0 from "./informationExpanded.vue?vue&type=style&index=0&id=fba2dbf2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba2dbf2",
  null
  
)

export default component.exports